import { Component } from '@angular/core';
import { UserSearchFilter } from '@app/_models';
import { UserService, DashboardService } from '@app/_services';
import { EventService } from '@app/_services/event.service';
import { first } from 'rxjs/operators';

@Component({ selector: 'community', templateUrl: 'community.component.html' })
export class CommunityComponent {

    filter: UserSearchFilter;
    userResults: any = [];
    sectors: any = [];
    upcomingEvents: any = [];

    constructor(private userService: UserService, private dashboardService: DashboardService, private eventService: EventService) {
        this.filter = new UserSearchFilter();
    }

    ngOnInit() {
        this.dashboardService.getSectors().pipe(first()).subscribe(data => {
            this.sectors = data;
        });

        this.eventService.getUpcomingEvents().pipe(first()).subscribe(events => {
            this.upcomingEvents = events.data;
        });

        this.dashboardService.getSectors().pipe(first()).subscribe(data => {
            this.sectors = data;
          });
    }

    search() {
        this.userService.search(this.filter).pipe(first()).subscribe(data => {
            this.userResults = data;
        });
    }

    getParticipantLink(userResult) {
        return ['/dashboard/community/participant/', userResult.userId.toString()];
    }
}